export default "__VITE_ASSET__B4Ke9e0T__"